import React from 'react';
import { Button } from '@wds/button';

import useTrackingDetails from '~pricing/hooks/useTrackingDetails';

import useCta from '~pricing/hooks/useCta';
import { generateCTAMetricsAttribute } from '~pricing/pages/shared/index';
import { PackageIds } from '~shared/constants/pricing';
import { usePackages } from '~shared/hooks/usePackages';
import { PackageCTAProps } from '~pricing/components/PackageCta/types';

import useStyles from './useStyles';

const PackageCta = ({ packageName, isSummaryPage = false }: PackageCTAProps): JSX.Element => {
  const { getPackageById } = usePackages();
  const { CTA, noCTA } = useStyles({ packageName });
  const packageId = PackageIds[packageName];
  const { pageName } = useTrackingDetails();
  const { isEnabled, ctaUrl, ctaLabel } = useCta(getPackageById(packageId));

  return (
    <div className={isEnabled ? CTA : noCTA}>
      <Button
        data-sm-metrics={generateCTAMetricsAttribute({
          pageName,
          packageId: `${packageId}`,
          packageName, // lowercase canonical_name
        })}
        href={ctaUrl}
        variant={isEnabled ? 'solid' : 'text'}
        disabled={!isEnabled}
        data-testid="PackageCta__Btn"
        size={isSummaryPage ? 'md' : 'sm'}
      >
        {ctaLabel}
      </Button>
    </div>
  );
};

export default PackageCta;
